export default __webpack_public_path__ + "static/media/opic-logo.79fb5e65.png";